/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileXml = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="m7.391 17 1.5-2.526-1.426-2.345h1.199l1.005 1.682.978-1.682H11.8l-1.434 2.365L11.873 17h-1.199l-1.085-1.843L8.543 17zm5.015 0v-4.87h1.092l1.548 3.208 1.528-3.209h1.092V17h-1.032v-3.156l-1.287 2.687h-.643l-1.286-2.647V17zm6.209 0v-4.87h1.046v3.939h2.144V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileXml as FileXml };
